/* @format */

import { api } from '@/scripts/api';

export const RegisteredDealsService = {
    getRegisteredDealsByMdfId(mdfId) {
        return new Promise((resolve, reject) => {
            const service = `/service/RegisteredDeals?$filter=(FundRequestId eq ${mdfId})`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getWonDealsByMdfId(mdfId) {
        return new Promise((resolve, reject) => {
            const service = `/service/Deals?$filter=IsWon eq true and RegisteredDeals/any(rd: rd/FundRequestId eq ${mdfId})&$expand=RegisteredDeals($filter=FundRequestId eq ${mdfId})`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getRegisteredDealsByPartnerId(partnerId) {
        return new Promise((resolve, reject) => {
            const service = `/service/RegisteredDeals?$filter=Deal/Contact/Client/Accounts/any(a: a/Id eq ${partnerId}) and FundRequestId ne null`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getWonDealsByPartnerId(partnerId) {
        return new Promise((resolve, reject) => {
            const service = `/service/Deals?$filter=IsWon eq true and Contact/Client/Accounts/any(a: a/Id eq ${partnerId}) and RegisteredDeals/any(rd: rd/FundRequestId ne null)&$expand=RegisteredDeals($filter=FundRequestId ne null)`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getCompanyByAgencyId(agencyId) {
        return new Promise((resolve, reject) => {
            const service = `/service/Agencies?$filter=Id eq ${agencyId}&$select=Id,Name,LogoImageUrl`;
            api.get(service).then(resolve).catch(reject);
        });
    },
};
